import { useContext, useEffect } from 'react';
import PhoneValidation from './PhoneValidation';
import ConfigContext from '../contexts/ConfigContext';

export default function AnswerOptions({
  data,
  defaultValue,
  disabled,
  navigateProcessing,
  options,
  selectedOption,
  slideKey,
  updateOtpMode,
  updateSelectedOption,
}: any) {
  const { features } = useContext(ConfigContext);

  useEffect(() => {
    if (features.useLocalInstallerDynamic) {
      return;
    } else {
      if (selectedOption) {
        updateSelectedOption(selectedOption);
      }
    }
  }, []);

  return (
    <>
      {slideKey === 'otp_verify' ? (
        <PhoneValidation
          slideKey={slideKey}
          updateOtpMode={updateOtpMode}
          navigateProcessing={navigateProcessing}
        />
      ) : (
        <div
          role="radiogroup"
          className={`flex flex-col w-auto md:w-[400px] ${
            slideKey === 'addressOwnership' ? 'mb-12' : ''
          }`}>
          {options.map((option: any, index: number) => {
            return (
              <div
                key={index}
                role="radio"
                aria-checked={option.value === selectedOption || !!defaultValue}
                onClick={
                  disabled
                    ? undefined
                    : () => updateSelectedOption(option.value)
                }
                className={`${index !== options.length - 1 ? 'mb-2' : ''} ${
                  features.showSunnyBot ? 'text-[14px]' : 'text-[17px]'
                } short:!text-[14px] md:text-base w-fit`}
                data-zuko-tag-name="BUTTON"
                data-zuko-id={`${slideKey}_option_${option.name
                  .replaceAll(' ', '_')
                  .toLowerCase()}`}>
                {option.name}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
